<!-- eslint-disable vue/valid-v-for -->
<template>
  <div class="residence-container">
    <div class="banner-container">
      <img
        src="../../../assets/images/residence/banner3.jpg"
      />
    </div>
    <p class="section-title-line">
      <span>锦悦系</span>
    </p>
    <div class="section-container intro-box-content">
      <p>乐趣，尽在花草间。</p>
      <p>双公园配置设计，演绎温情美好的天伦魅力。</p>
      <p>让爱化作心意，</p>
      <p>回归家庭，人生尽从容。</p>
      <p>缔造艺术舒居。</p>
      <p>一座活泼亲切的幸福乐园，</p>
      <p>献给更爱家庭的你。</p>
    </div>

    <div class="section-container">
      <div v-for="(item, index) in list" :key="item.name + index">
        <project-show :data="item"></project-show>
      </div>
    </div>
  </div>
</template>
<script>
import ProjectShow from "@/components/projectShow";

export default {
  name: "JinYueXiPage",
  components: {
    ProjectShow,
  },
  data() {
    return {
      list: [
        {
          name: "新希望·锦悦北府",
          title: "公园大宅 宜居标杆",
          desc: [
            "千年新都，实力崛起，北部新城，璞玉绽放。",
            "新希望·锦悦北府，公园宜居大宅，",
            "香城改善人居里程碑。",
            "<br />",
            "<br />",
            "* 天生高贵锦悦系，规划、配套、公园3重升级",
            "* 落址北四环，临近国际商贸城，静谧与繁华轻松切换",
            "* 住宅、商业、公园多重规划，3大主题公园亮点突出",
            "* 点式围合布局，中庭面积接近12000㎡",
            "* 五重景观搭配，公园舒居体验",
          ],
          footer: [
            "Tel：+86（28）6661 1117",
            "Add：成都·新都区·万石路与新竹大道路口",
          ],
          images: [
            require("../../../assets/images/residence/jybf-1.png"),
            require("../../../assets/images/residence/jybf-2.png"),
            require("../../../assets/images/residence/jybf-3.png"),
            require("../../../assets/images/residence/jybf-4.png"),
            require("../../../assets/images/residence/jybf-5.png"),
          ],
        },
        {
          name: "新希望·锦悦楠庭",
          title: "高门重檐 大院洋房",
          desc: [
            "20载匠心淬炼，一朝华丽绽放。",
            "2017年，新希望·锦悦楠庭，",
            "集大院洋房营造之大成，",
            "璀璨登场，致敬成都。",
            "<br />",
            "<br />",
            "* 领踞武侯新城核心地段，落址武兴路和金江路交汇处",
            "* 紧邻3号线双凤桥站，立体交通四通八达",
            "* 匠造蜀锦大院川派园林，5000㎡奢阔中庭私家花园",
            "* 2.0低密容积率，8层纯洋房社区，奢居典范",
          ],
          footer: [
            "Tel：+86（28）8666 9993",
            "Add：成都·武侯区·武兴路和金江路交汇处",
          ],
          images: [
            require("../../../assets/images/residence/jynt-1.jpg"),
            require("../../../assets/images/residence/jynt-2.jpg"),
            require("../../../assets/images/residence/jynt-3.png"),
            require("../../../assets/images/residence/jynt-4.png"),
            require("../../../assets/images/residence/jynt-5.png"),
            require("../../../assets/images/residence/jynt-6.jpg"),
          ],
        },
        {
          name: "新希望·锦悦青山",
          title: "邕脉山居 岂止城心",
          desc: [
            "荟萃一城繁华，掌控中央都市生活。",
            "2018年，新希望·锦悦青山，致献南宁峰层人士。",
            "集丰沛山水、人文资源为一体，",
            "引领舒适山居新时代。",
            "<br />",
            "<br />",
            "* 雄踞交通要塞，畅览邕城大地",
            "* 国际化都市配套，畅享峰层人士生活",
            "* 守护全龄健康，畅享青山绿氧",
            "* 背倚青山揽邕水，俯仰皆为人生大境",
            "* 执掌城心繁华，尽揽城市万象",
          ],
          footer: [
            // "Tel：+86（571）8215 6888",
            "Add：广西壮族自治区南宁市青秀区柳园路东一里1号",
          ],
          images: [
            require("../../../assets/images/residence/jyqs-1.png"),
            require("../../../assets/images/residence/jyqs-2.png"),
            require("../../../assets/images/residence/jyqs-3.png"),
            require("../../../assets/images/residence/jyqs-4.png"),
          ],
        },
      ],
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
};
</script>
<style lang="scss" scoped>
.residence-container {
}
</style>
